export type Directive = 'nohistory';

export const addDirective = (query: string, directive: Directive) =>
  !query.includes(`#${directive}`) ? `#${directive} ${query}` : query;

export const removeDirective = (query: string) =>
  query.replace(/^#(\w+)/, '').trim();
